import t from "./_baseMatches.js";
import e from "./_baseMatchesProperty.js";
import o from "./identity.js";
import i from "./isArray.js";
import p from "./property.js";
var f = t, s = e, n = o, a = i, m = p;
function y(r) {
  return typeof r == "function" ? r : r == null ? n : typeof r == "object" ? a(r) ? s(r[0], r[1]) : f(r) : m(r);
}
var d = y;
export {
  d as default
};
//# sourceMappingURL=_baseIteratee.js.map
